module.exports = __webpack_public_path__ + "img/1_2023_11_20.efece453.png";